import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/logout',
  exact: true,
  name: 'navigation.menu.signout',
  private: true,
  type: containerTypes.CONTENT,
};

export default RouteConfig;
